import React from 'react';
import Home from './home';
import SalesDashboard from './home/sales';
import OperationsDashboard from './home/operations';
import HeadOfficeDashboard from './headOffice/analytics';
import Profile from './profile';
import GoCardlessAuthorizationCallback from './payments/methods/GoCardless/AuthorizationCallback';
import StripeAuthorizationCallback from './payments/methods/Stripe/AuthorizationCallback';
import StripeAuthorizationRefreshCallback from './payments/methods/Stripe/AuthorizationRefreshCallback';
import Franchisees from './franchisees';
import FranchiseeDetails from './franchisees/Details';
import Terms from './terms';
import TermDetails from './terms/Details';
import Roles from './roles';
import RoleDetails from './roles/Details';
import Users from './users';
import UserDetails from './users/Details';
import Grades from './grades';
import GradeDetails from './grades/Details';
import Prices from './prices';
import PriceDetails from './prices/Details';
import Discounts from './discounts';
import DiscountDetails from './discounts/Details';
import DocumentForms from './documentForms';
import DocumentFormDetails from './documentForms/Details';
import Parents from './parents';
import ParentDetails from './parents/Details';
import WeeklyPrograms from './weeklyPrograms';
import CenterDetails from './centers/Details';
import WeeklyProgramDetails from './weeklyPrograms/Details';
import Permissions from './permissions';
import TrialLessons from './trialLessons';
import WaitingList from './waitingList';
import WaitingListDetails from './waitingList/Details';
import PaymentConfiguration from './settings/payments';
import Vouchers from './vouchers';
import VoucherDetails from './vouchers/Details';
import PaymentHistory from './paymentHistory';
import InstalmentPayments from './instalmentPayments';
import Enrolments from './enrolments';
import PaymentHistoryDetails from './paymentHistory/Details';
import EnrolmentDetails from './enrolments/Details';
import HowYouLearn from './howYouLearn';
import ReportParentsNotChooseCenter from './reports/parentsNotChooseCenter';
import ReportChildren from './reports/reportChildren';
import LoyalChildren from './reports/loyalChildren';
import MessageTemplates from './messageTemplates';
import MessageTemplateDetails from './messageTemplates/Details';
import LessonAttendance from './attendance';
import ManageLessonAttendance from './attendance/ManageLessonAttendance';
import WeeklyInformations from './weeklyInformations';
import WeeklyInformationDetails from './weeklyInformations/Details';
import FranchisorSettings from './settings/franchisor';
import KindergartenWeeklyProgram from './kindergartenAttendance';
import KindergartenLessonAttendance from './kindergartenAttendance/ManageAttendance';
import IndividualConsultations from './individualConsultations';
import IndividualConsultationDetails from './individualConsultations/Details';
import IvidualConsultationFormdeDetails from './individualConsultationForms/Details';
import KindergartenMonthlyReport from './reports/kindergartenMonthly';
import MonthlyPaymentReport from './reports/monthlyPayment';
import FinancialReport from './reports/financialReport';
import MoveChildLessonsComponent from './moveLessons';
import IndividualConsultationsSchedule from './individualConsultationsSchedule';
import IndividualConsultationsScheduleDetails from './individualConsultationsSchedule/Details';
import SessionManagementReport from './reports/sessionManagement';
import PrepaidTermsReport from './reports/prepaidTerms';
import RoyaltyReport from './reports/royaltyReport';
import CentralisedRoyaltyReport from './reports/centralisedRoyalty';
import CancellationCreditNotesReport from './reports/cancellationCreditNotes';
import SoftwareFeeReport from './reports/softwareFee';
import MasterFranchisees from './headOffice/masterFranchisees';
import UpcomingCancellations from './reports/upcomingCancellations';
import EmailBounces from './emailBounces';
import ZoomAuthorizationCallback from './zoom/AuthorizationCallback';
import CampaignStats from './reports/campaignStats';
import SelfAssessments from './selfAssessments';
import SelfAssessmentDetails from './selfAssessments/Details';
import Workshops from './workshops';
import WorkshopDetails from './workshops/Details';
import WorkshopAttendance from './workshopAttendance';
import WorkshopWeekAttendance from './workshopAttendance/Week';
import WorkshopPayments from './workshopPayments';
import WorkshopPaymentDetails from './workshopPayments/Details';
import SentEmails from './reports/sentEmails';
import InstalmentPlans from './instalmentPlans';
import InstalmentPlanDetails from './instalmentPlans/Details'
import TermHolidayPeriods from './termHolidayPeriods';
import TermHolidayPeriodDetails from './termHolidayPeriods/Details';

const menus = {
    DASHBOARD: 'dashboard',
    ADMIN: 'admin',
    CURRICULUM: 'curriculum',
    FINANCES: 'finances',
    REPORTS: 'reports',
    SETTINGS: 'settings'
};

const routes = [
    {
        showInMainMenu: () => true,
        textResourceKey: 'MainMenu_Dashboard',
        pageTitleResourceKey: 'PageTitle_Dashboard',
        icon: 'clip-home-3',
        mainContent: Home,
        menuName: menus.DASHBOARD
    },
    {
        exact: true,
        showInMainMenu: () => true,
        textResourceKey: 'MainMenu_Admin',
        icon: 'clip-cogs',
        menuName: menus.ADMIN
    },
    {
        path: '/profile',
        showInMainMenu: () => false,
        pageTitleResourceKey: 'PageTitle_Profile',
        mainContent: Profile
    },
    {
        path: '/payments/gocardless/callback',
        exact: true,
        showInMainMenu: () => false,
        mainContent: GoCardlessAuthorizationCallback
    },
    {
        path: '/payments/stripe/callback',
        exact: true,
        showInMainMenu: () => false,
        mainContent: StripeAuthorizationCallback
    },
    {
        path: '/payments/stripe/refresh-callback',
        exact: true,
        showInMainMenu: () => false,
        mainContent: StripeAuthorizationRefreshCallback
    },
    {
        path: '/zoom/callback',
        exact: true,
        showInMainMenu: () => false,
        mainContent: ZoomAuthorizationCallback
    },
    {
        path: '/users/new',
        showInMainMenu: () => false,
        mainMenuPath: '/users',
        pageTitleResourceKey: 'PageTitle_NewUser',
        mainContent: UserDetails
    },
    {
        path: '/users/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/users',
        pageTitleResourceKey: 'PageTitle_EditUser',
        mainContent: UserDetails
    },
    {
        path: '/permissions/:objectType/:objectId/:objectName',
        exact: true,
        showInMainMenu: () => false,
        businessFunctionName: 'SecuritySettings',
        pageTitleResourceKey: 'PageTitle_Permissions',
        mainContent: Permissions
    },
    {
        path: '/roles/new',
        showInMainMenu: () => false,
        pageTitleResourceKey: 'PageTitle_NewRole',
        mainContent: RoleDetails
    },
    {
        path: '/roles/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/roles',
        pageTitleResourceKey: 'PageTitle_EditRole',
        mainContent: RoleDetails
    },
    {
        path: '/parents',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'Parents',
        textResourceKey: 'MainMenu_Parents',
        icon: 'clip-users',
        pageTitleResourceKey: 'PageTitle_Parents',
        mainContent: Parents
    },
    {
        path: '/parents/new',
        showInMainMenu: () => false,
        mainMenuPath: '/parents',
        pageTitleResourceKey: 'PageTitle_NewParent',
        mainContent: ParentDetails
    },
    {
        path: '/parents/:id/:tab?',
        showInMainMenu: () => false,
        mainMenuPath: '/parents',
        pageTitleResourceKey: 'PageTitle_EditParent',
        mainContent: ParentDetails
    },
    {
        path: '/headOffice/masterFranchisees',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'MasterFranchisees',
        textResourceKey: 'MainMenu_MasterFranchisees',
        icon: 'clip-user-5',
        pageTitleResourceKey: 'PageTitle_MasterFranchisees',
        mainContent: MasterFranchisees
    },
    {
        path: '/franchisees',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'Franchisees',
        textResourceKey: 'MainMenu_Franchisees',
        icon: 'clip-user-5',
        pageTitleResourceKey: 'PageTitle_Franchisees',
        mainContent: Franchisees
    },
    {
        path: '/franchisees/new',
        showInMainMenu: () => false,
        mainMenuPath: '/franchisees',
        pageTitleResourceKey: 'PageTitle_FranchiseeRegistration',
        mainContent: FranchiseeDetails
    },
    {
        path: '/franchisees/:id/:tab?',
        showInMainMenu: () => false,
        mainMenuPath: '/franchisees',
        pageTitleResourceKey: 'PageTitle_EditFranchisee',
        mainContent: FranchiseeDetails
    },
    {
        exact: true,
        showInMainMenu: () => true,
        textResourceKey: 'MainMenu_Curriculum',
        icon: 'clip-calendar',
        menuName: menus.CURRICULUM
    },
    {
        path: '/grades/new',
        showInMainMenu: () => false,
        mainMenuPath: '/grades',
        pageTitleResourceKey: 'PageTitle_NewGrade',
        mainContent: GradeDetails
    },
    {
        path: '/grades/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/grades',
        pageTitleResourceKey: 'PageTitle_EditGrade',
        mainContent: GradeDetails
    },
    {
        path: '/weeklyInformations/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/weeklyInformations',
        pageTitleResourceKey: 'PageTitle_EditWeeklyInformation',
        mainContent: WeeklyInformationDetails
    },
    {
        path: '/terms/new',
        showInMainMenu: () => false,
        mainMenuPath: '/terms',
        pageTitleResourceKey: 'PageTitle_NewTerm',
        mainContent: TermDetails
    },
    {
        path: '/terms/:id/:tab?',
        showInMainMenu: () => false,
        mainMenuPath: '/terms',
        pageTitleResourceKey: 'PageTitle_EditTerm',
        mainContent: TermDetails
    },
    {
        path: '/termHolidayPeriods/new',
        showInMainMenu: () => false,
        pageTitleResourceKey: 'PageTitle_NewTermHolidayPeriod',
        mainContent: TermHolidayPeriodDetails
    },
    {
        path: '/termHolidayPeriods/:id',
        showInMainMenu: () => false,
        pageTitleResourceKey: 'PageTitle_EditTermHolidayPeriod',
        mainContent: TermHolidayPeriodDetails
    },
    {
        path: '/workshops/new',
        showInMainMenu: () => false,
        mainMenuPath: '/workshops',
        pageTitleResourceKey: 'PageTitle_NewWorkshop',
        mainContent: WorkshopDetails
    },
    {
        path: '/workshops/:id/:tab?',
        showInMainMenu: () => false,
        mainMenuPath: '/workshops',
        pageTitleResourceKey: 'PageTitle_EditWorkshop',
        mainContent: WorkshopDetails
    },
    {
        exact: true,
        showInMainMenu: () => true,
        textResourceKey: 'MainMenu_Finances',
        icon: 'clip-banknote',
        menuName: menus.FINANCES
    },
    {
        path: '/prices/new',
        showInMainMenu: () => false,
        mainMenuPath: '/prices',
        pageTitleResourceKey: 'PageTitle_NewPrice',
        mainContent: PriceDetails
    },
    {
        path: '/prices/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/prices',
        pageTitleResourceKey: 'PageTitle_EditPrice',
        mainContent: PriceDetails
    },
    {
        path: '/discounts/new',
        showInMainMenu: () => false,
        mainMenuPath: '/discounts',
        pageTitleResourceKey: 'PageTitle_NewDiscount',
        mainContent: DiscountDetails
    },
    {
        path: '/discounts/:id/:tab?',
        showInMainMenu: () => false,
        mainMenuPath: '/discounts',
        pageTitleResourceKey: 'PageTitle_EditDiscount',
        mainContent: DiscountDetails
    },
    {
        path: '/vouchers/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/vouchers',
        pageTitleResourceKey: 'PageTitle_EditVoucher',
        mainContent: VoucherDetails
    },
    {
        exact: true,
        showInMainMenu: () => true,
        icon: 'clip-stats',
        textResourceKey: 'MainMenu_Reports',
        menuName: menus.REPORTS
    },
    {
        path: '/weeklyProgram/new',
        showInMainMenu: () => false,
        mainMenuPath: '/weeklyProgram',
        pageTitleResourceKey: 'NewWeeklyProgram',
        mainContent: CenterDetails,
        backTo: '/weeklyProgram'
    },
    {
        path: '/weeklyProgram/action',
        showInMainMenu: () => false,
        mainMenuPath: '/weeklyProgram',
        mainContent: WeeklyProgramDetails
    },
    {
        path: '/trialLesson',
        exact: true,
        showInMainMenu: (franchisor) => franchisor.enableTrials,
        businessFunctionName: 'TrialLessons',
        textResourceKey: 'MainMenu_TrialLesson',
        icon: 'clip-atom',
        pageTitleResourceKey: 'PageTitle_TrialLesson',
        mainContent: TrialLessons
    },
    {
        path: '/waitingList',
        exact: true,
        showInMainMenu: (franchisor) => franchisor.enableWaitingList,
        businessFunctionName: 'WaitingList',
        textResourceKey: 'MainMenu_WaitingList',
        icon: 'clip-download',
        pageTitleResourceKey: 'PageTitle_WaitingList',
        mainContent: WaitingList
    },
    {
        path: '/waitingList/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/waitingList',
        pageTitleResourceKey: 'PageTitle_WaitingListDetails',
        mainContent: WaitingListDetails
    },
    {
        path: '/individualConsultations',
        exact: true,
        showInMainMenu: (franchisor) => franchisor.offerIndividualConsultations,
        businessFunctionName: 'IndividualConsultations',
        textResourceKey: 'MainMenu_IndividualConsultations',
        icon: 'clip-bubbles-2',
        pageTitleResourceKey: 'PageTitle_IndividualConsultations',
        mainContent: IndividualConsultations
    },
    {
        path: '/individualConsultations/:id/:parentId/:tab',
        showInMainMenu: () => false,
        mainMenuPath: '/individualConsultations',
        pageTitleResourceKey: 'PageTitle_EditIndividualConsultation',
        mainContent: IndividualConsultationDetails
    },
    {
        path: '/individualConsultationForms/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/parents',
        pageTitleResourceKey: '', //'PageTitle_individualConsultationFormDetails',
        mainContent: IvidualConsultationFormdeDetails
    },
    {
        path: '/selfAssessments/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/parents',
        pageTitleResourceKey: 'PageTitle_Child_SelfAssessment',
        mainContent: SelfAssessmentDetails
    },
    {
        path: '/individualConsultationsSchedule/new',
        showInMainMenu: () => false,
        mainMenuPath: '/individualConsultationsSchedule',
        pageTitleResourceKey: 'PageTitle_NewIndividualConsultationsScheduleItem',
        mainContent: IndividualConsultationsScheduleDetails
    },
    {
        path: '/individualConsultationsSchedule/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/individualConsultationsSchedule',
        pageTitleResourceKey: 'PageTitle_EditIndividualConsultationsScheduleItem',
        mainContent: IndividualConsultationsScheduleDetails
    },
    {
        path: '/lessonAttendance',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'ChildLessons',
        textResourceKey: 'MainMenu_LessonAttendance',
        icon: 'clip-checkmark',
        pageTitleResourceKey: 'PageTitle_ManageLessonAttendance',
        mainContent: LessonAttendance
    },
    {
        path: '/lessonAttendance/manage',
        showInMainMenu: () => false,
        mainMenuPath: '/lessonAttendance',
        pageTitleResourceKey: 'PageTitle_ManageLessonAttendance',
        mainContent: ManageLessonAttendance,
        backTo: '/lessonAttendance'
    },
    {
        path: '/workshopAttendance',
        exact: true,
        showInMainMenu: (franchisor) => franchisor.offerWorkshops,
        businessFunctionName: 'Workshops',
        textResourceKey: 'MainMenu_WorkshopAttendance',
        icon: 'clip-wand',
        pageTitleResourceKey: 'PageTitle_ManageWorkshopAttendance',
        mainContent: WorkshopAttendance
    },
    {
        path: '/workshopAttendance/workshop/:workshopId/week/:weekId',
        showInMainMenu: () => false,
        mainMenuPath: '/workshopAttendance',
        pageTitleResourceKey: 'PageTitle_ManageWorkshopAttendance',
        mainContent: WorkshopWeekAttendance,
        backTo: '/workshopAttendance'
    },
    {
        path: '/kindergartenAttendance',
        exact: true,
        showInMainMenu: (franchisor) => franchisor.workWithKindergarten,
        businessFunctionName: 'KindergartenAttendance',
        textResourceKey: 'MainMenu_KindergartenAttendance',
        icon: 'clip-book',
        pageTitleResourceKey: 'PageTitle_KindergartenWeeklyProgram',
        mainContent: KindergartenWeeklyProgram
    },
    {
        path: '/kindergartenAttendance/manage',
        showInMainMenu: () => false,
        mainMenuPath: '/kindergartenAttendance',
        pageTitleResourceKey: 'PageTitle_ManageKindergartenAttendance',
        mainContent: KindergartenLessonAttendance,
        backTo: '/kindergartenAttendance'
    },
    {
        path: '/moveChildLessons',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'MoveChildLessons',
        textResourceKey: 'MainMenu_MoveChildLessons',
        icon: 'clip-rotate',
        pageTitleResourceKey: 'PageTitle_MoveChildLessons',
        mainContent: MoveChildLessonsComponent
    },
    {
        path: '/weeklyInformations',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'WeeklyInformations',
        textResourceKey: 'MainMenu_WeeklyInformation',
        icon: 'clip-info',
        pageTitleResourceKey: 'PageTitle_WeeklyInformation',
        mainContent: WeeklyInformations
    },
    {
        path: '/weeklyInformations/new',
        showInMainMenu: () => false,
        mainMenuPath: '/weeklyInformations',
        pageTitleResourceKey: 'PageTitle_NewWeeklyInformation',
        mainContent: WeeklyInformationDetails
    },
    {
        path: '/documentForms',
        exact: true,
        showInMainMenu: () => true,
        businessFunctionName: 'DocumentForm',
        textResourceKey: 'MainMenu_DocumentsAndForms',
        icon: 'clip-list',
        pageTitleResourceKey: 'PageTitle_DocumentsAndForms',
        mainContent: DocumentForms
    },
    {
        path: '/documentForms/new',
        showInMainMenu: () => false,
        mainMenuPath: '/documentForms',
        pageTitleResourceKey: 'NewDocumentForm',
        mainContent: DocumentFormDetails
    },
    {
        path: '/documentForms/:id',
        showInMainMenu: () => false,
        mainMenuPath: '/documentForms',
        pageTitleResourceKey: 'EditDocumentForm',
        mainContent: DocumentFormDetails
    },
    {
        exact: true,
        showInMainMenu: () => true,
        icon: 'clip-settings',
        textResourceKey: 'MainMenu_Settings',
        pageTitleResourceKey: 'PageTitle_Settings',
        menuName: menus.SETTINGS
    }
];

export const submenus = {
    [menus.DASHBOARD]: [
        {
            path: '/',
            exact: true,
            showInMainMenu: () => false,
            mainContent: Home
        },
        {
            path: '/home/sales',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'SalesDashboard',
            textResourceKey: 'MainMenu_SalesDashboard',
            pageTitleResourceKey: 'PageTitle_SalesDashboard',
            mainContent: SalesDashboard
        },
        {
            path: '/home/operations',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'OperationsDashboard',
            textResourceKey: 'MainMenu_OperationsDashboard',
            pageTitleResourceKey: 'PageTitle_OperationsDashboard',
            mainContent: OperationsDashboard
        },
        {
            path: '/home/headOffice',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'MasterFranchisees',
            textResourceKey: 'MainMenu_HeadOfficeDashboard',
            pageTitleResourceKey: 'PageTitle_HeadOfficeDashboard',
            mainContent: HeadOfficeDashboard
        }
    ],
    [menus.ADMIN]: [
        {
            path: '/users',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Users',
            textResourceKey: 'MainMenu_Users',
            pageTitleResourceKey: 'PageTitle_Users',
            mainContent: Users,
        },
        {
            path: '/roles',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'UserRoles',
            textResourceKey: 'MainMenu_Roles',
            pageTitleResourceKey: 'PageTitle_Roles',
            mainContent: Roles
        },
        {
            path: '/emailBounces',
            exact: true,
            // bounce records cannot be filtered per center, so the screen is for users with access to all centers
            showInMainMenu: (franchisor, currentUser) => !currentUser.isCenterRestricted && !currentUser.isFranchiseeRestricted,
            businessFunctionName: 'EmailBounces',
            textResourceKey: 'MainMenu_EmailBounces',
            pageTitleResourceKey: 'PageTitle_EmailBounces',
            mainContent: EmailBounces
        }
    ],
    [menus.CURRICULUM]: [
        {
            path: '/grades',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Grades',
            textResourceKey: 'MainMenu_Grades',
            icon: 'clip-tux',
            pageTitleResourceKey: 'PageTitle_Grades',
            mainContent: Grades
        },
        {
            path: '/terms',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Terms',
            textResourceKey: 'MainMenu_Terms',
            icon: 'clip-calendar',
            pageTitleResourceKey: 'PageTitle_Terms',
            mainContent: Terms
        },
        {
            path: '/termHolidayPeriods',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'TermHolidayPeriod',
            textResourceKey: 'MainMenu_TermHolidayPeriods',
            icon: 'clip-calendar',
            pageTitleResourceKey: 'PageTitle_TermHolidayPeriods',
            mainContent: TermHolidayPeriods
        },
        {
            path: '/weeklyProgram',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'WeeklyPrograms',
            textResourceKey: 'MainMenu_WeeklyProgram',
            icon: 'clip-calendar',
            pageTitleResourceKey: 'PageTitle_WeeklyProgram',
            mainContent: WeeklyPrograms
        },
        {
            path: '/individualConsultationsSchedule',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.offerIndividualConsultations,
            businessFunctionName: 'IndividualConsultationsSchedule',
            textResourceKey: 'MainMenu_IndividualConsultationsSchedule',
            icon: 'clip-file',
            pageTitleResourceKey: 'PageTitle_IndividualConsultationsSchedule',
            mainContent: IndividualConsultationsSchedule
        },
        {
            path: '/workshops',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.offerWorkshops,
            businessFunctionName: 'Workshops',
            textResourceKey: 'MainMenu_Workshops',
            icon: 'clip-calendar',
            pageTitleResourceKey: 'PageTitle_Workshops',
            mainContent: Workshops
        },
    ],
    [menus.FINANCES]: [
        {
            path: '/prices',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Prices',
            textResourceKey: 'MainMenu_Prices',
            pageTitleResourceKey: 'PageTitle_Prices',
            mainContent: Prices
        },
        {
            path: '/discounts',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Discounts',
            textResourceKey: 'MainMenu_Discounts',
            pageTitleResourceKey: 'PageTitle_Discounts',
            mainContent: Discounts
        },
        {
            path: '/instalmentPlans',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.enableInstalmentPayment,
            mainMenuPath: '/instalmentPlans',
            businessFunctionName: 'InstalmentPlans',
            textResourceKey: 'MainMenu_InstalmentPlans',
            pageTitleResourceKey: 'PageTitle_InstalmentPlans',
            mainContent: InstalmentPlans
        },
        {
            path: '/instalmentPlans/new',
            showInMainMenu: () => false,
            mainMenuPath: '/instalmentPlans',
            pageTitleResourceKey: 'PageTitle_NewInstalmentPlan',
            mainContent: InstalmentPlanDetails
        },
        {
            path: '/instalmentPlans/:id',
            showInMainMenu: () => false,
            mainMenuPath: '/instalmentPlans',
            pageTitleResourceKey: 'PageTitle_EditInstalmentPlan',
            mainContent: InstalmentPlanDetails
        },
        {
            path: '/paymentHistory',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_PaymentHistory',
            pageTitleResourceKey: 'PageTitle_PaymentHistory',
            mainContent: PaymentHistory
        },
        {
            path: '/paymentHistory/:id',
            showInMainMenu: () => false,
            mainMenuPath: '/paymentHistory',
            pageTitleResourceKey: 'PageTitle_EditPaymentHistory',
            mainContent: PaymentHistoryDetails
        },
        {
            path: '/workshopPayments',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.offerWorkshops,
            businessFunctionName: 'WorkshopPayments',
            textResourceKey: 'MainMenu_WorkshopPayments',
            pageTitleResourceKey: 'PageTitle_WorkshopPayments',
            mainContent: WorkshopPayments
        },
        {
            path: '/workshopPayments/:id',
            showInMainMenu: () => false,
            mainMenuPath: '/workshopPayments',
            pageTitleResourceKey: 'PageTitle_WorkshopPaymentDetails',
            mainContent: WorkshopPaymentDetails
        },

        {
            path: '/instalmentPayments/:tab?',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.enableInstalmentPayment,
            mainMenuPath: '/instalmentPayments/orders',
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_InstalmentPayments',
            pageTitleResourceKey: 'PageTitle_InstalmentPayments',
            mainContent: InstalmentPayments
        },
        {
            path: '/reports/monthlyPayment',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'FinancialReport',
            textResourceKey: 'MainMenu_MonthlyPaymentReport',
            pageTitleResourceKey: 'PageTitle_MonthlyPaymentReport',
            mainContent: MonthlyPaymentReport
        },
        {
            path: '/reports/financialReport',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.showAnnualFinancialReport,
            businessFunctionName: 'FinancialReport',
            textResourceKey: 'MainMenu_FinancialReport',
            pageTitleResourceKey: 'PageTitle_FinancialReport',
            mainContent: FinancialReport
        },
        {
            path: '/reports/royalty',
            exact: true,
            showInMainMenu: (franchisor) => !franchisor.centralisedPayments,
            businessFunctionName: 'FinancialReport',
            textResourceKey: 'MainMenu_RoyaltyReport',
            pageTitleResourceKey: 'PageTitle_RoyaltyReport',
            mainContent: RoyaltyReport
        },
        {
            path: '/reports/centralisedRoyalty',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.centralisedPayments,
            businessFunctionName: 'FinancialReport',
            textResourceKey: 'MainMenu_RoyaltyReport',
            pageTitleResourceKey: 'PageTitle_RoyaltyReport',
            mainContent: CentralisedRoyaltyReport
        },
        {
            path: '/reports/softwareFee',
            exact: true,
            showInMainMenu: (franchisor) => true,
            businessFunctionName: 'FinancialReport',
            textResourceKey: 'MainMenu_SoftwareFeeReport',
            pageTitleResourceKey: 'PageTitle_SoftwareFeeReport',
            mainContent: SoftwareFeeReport
        },
        {
            path: '/reports/upcomingCancellations',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_UpcomingCancellations',
            pageTitleResourceKey: 'PageTitle_UpcomingCancellations',
            mainContent: UpcomingCancellations
        },
        {
            path: '/reports/kindergartenMonthlyReport',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.workWithKindergarten,
            businessFunctionName: 'KindergartenMonthlyReport',
            textResourceKey: 'MainMenu_KindergartenMonthlyReport',
            pageTitleResourceKey: 'PageTitle_KindergartenMonthlyReport',
            mainContent: KindergartenMonthlyReport
        },
        {
            path: '/reports/campaignStats',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_CampaignStats',
            pageTitleResourceKey: 'PageTitle_CampaignStats',
            mainContent: CampaignStats
        }
    ],
    [menus.REPORTS]: [
        {
            path: '/enrolments',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_ReportsEnrolled',
            pageTitleResourceKey: 'PageTitle_Enrolments',
            mainContent: Enrolments
        },
        {
            offset: true,
            path: '/enrolments',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PaymentHistory',
            textResourceKey: 'MainMenu_Enrolments',
            pageTitleResourceKey: 'PageTitle_Enrolments',
            mainContent: Enrolments
        },
        {
            offset: true,
            path: '/enrolments/:id',
            showInMainMenu: () => false,
            mainMenuPath: '/enrolments',
            pageTitleResourceKey: 'PageTitle_EnrolmentDetails',
            mainContent: EnrolmentDetails
        },
        {
            offset: true,
            path: '/reports/reportChildren/paidForTerm',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ParentsPaidForTerm',
            pageTitleResourceKey: 'PageTitle_ParentsPaidForTerm',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/reportChildren/enrolledForTrialLesson',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.enableTrials,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ParentsEnrolledForTrialLesson',
            pageTitleResourceKey: 'PageTitle_ParentsEnrolledForTrialLesson',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/reportChildren/newChildrenForTerm',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_NewChildrenForTerm',
            pageTitleResourceKey: 'PageTitle_NewChildrenForTerm',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/loyalChildren',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_LoyalChildren',
            pageTitleResourceKey: 'PageTitle_LoyalChildren',
            mainContent: LoyalChildren
        },
        {
            path: '/reports/reportChildren/chosenCenterNotBooked',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ReportsUnenrolled',
            pageTitleResourceKey: 'PageTitle_ParentsChoosedCenterNotBooked',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/reportChildren/chosenCenterNotBooked',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ParentsChoosedCenterNotBooked',
            pageTitleResourceKey: 'PageTitle_ParentsChoosedCenterNotBooked',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/parentsNotChosenCenter',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParentNotChooseCenter',
            textResourceKey: 'MainMenu_ParentsNotChooseCenter',
            pageTitleResourceKey: 'PageTitle_ParentsNotChooseCenter',
            mainContent: ReportParentsNotChooseCenter
        },
        {
            offset: true,
            path: '/reports/reportChildren/paidPrevTerm',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ParentsPaidPrevTerm',
            pageTitleResourceKey: 'PageTitle_ParentsPaidPrevTerm',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/prepaidTermsReport',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'PrepaidTermsReport',
            textResourceKey: 'MainMenu_PrepaidTermsReport',
            pageTitleResourceKey: 'PageTitle_PrepaidTermsReport',
            mainContent: PrepaidTermsReport
        },
        {
            path: '/reports/sessionManagement',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ReportsOther',
            pageTitleResourceKey: 'PageTitle_SessionManagementReport',
            mainContent: SessionManagementReport
        },
        {
            offset: true,
            path: '/reports/sessionManagement',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_SessionManagementReport',
            pageTitleResourceKey: 'PageTitle_SessionManagementReport',
            mainContent: SessionManagementReport
        },
        {
            offset: true,
            path: '/reports/reportChildren/childrenByGradeForTerm',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ChildrenByGradeForTerm',
            pageTitleResourceKey: 'PageTitle_ChildrenByGradeForTerm',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/howYouLearn',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'Parents',
            textResourceKey: 'MainMenu_HowYouLearn',
            pageTitleResourceKey: 'PageTitle_HowYouLearn',
            mainContent: HowYouLearn
        },
        {
            offset: true,
            path: '/reports/reportChildren/childrenWithoutMedicalInformation',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.enableCollectMedicalInformation,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_ChildrenWithoutMedicalInformation',
            pageTitleResourceKey: 'PageTitle_ChildrenWithoutMedicalInformation',
            mainContent: ReportChildren
        },
        {
            offset: true,
            path: '/reports/reportChildren/cancellationCreditNotes',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'ReportParents',
            textResourceKey: 'MainMenu_CancellationCreditNotes',
            pageTitleResourceKey: 'PageTitle_CancellationCreditNotes',
            mainContent: CancellationCreditNotesReport
        },
        {
            offset: true,
            path: '/selfAssessments',
            exact: true,
            showInMainMenu: (franchisor) => franchisor.enableSelfAssessments,
            businessFunctionName: 'SelfAssessmentsReport',
            textResourceKey: 'MainMenu_SelfAssessments',
            pageTitleResourceKey: 'PageTitle_SelfAssessments',
            mainContent: SelfAssessments
        },
        {
            offset: true,
            path: '/sentEmails',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'SentEmails',
            textResourceKey: 'MainMenu_SentEmails',
            pageTitleResourceKey: 'PageTitle_SentEmails',
            mainContent: SentEmails
        }
    ],

    [menus.SETTINGS]: [
        {
            path: '/settings/franchisor',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'FranchisorSettings',
            textResourceKey: 'MainMenu_FranchisorSettings',
            pageTitleResourceKey: 'PageTitle_FranchisorSettings',
            mainContent: FranchisorSettings
        },
        {
            path: '/settings/payments',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'FranchisorSettings',
            textResourceKey: 'MainMenu_PaymentConfiguration',
            pageTitleResourceKey: 'PageTitle_PaymentConfiguration',
            mainContent: PaymentConfiguration
        },
        {
            path: '/messageTemplates',
            exact: true,
            showInMainMenu: () => true,
            businessFunctionName: 'MessageTemplates',
            textResourceKey: 'MainMenu_MessageTemplates',
            pageTitleResourceKey: 'PageTitle_MessageTemplates',
            mainContent: MessageTemplates
        },
        {
            path: '/messageTemplates/:category/new',
            showInMainMenu: () => false,
            mainMenuPath: '/messageTemplates',
            pageTitleResourceKey: 'PageTitle_NewMessageTemplate',
            mainContent: MessageTemplateDetails
        },
        {
            path: '/messageTemplates/:id',
            showInMainMenu: () => false,
            mainMenuPath: '/messageTemplates',
            pageTitleResourceKey: 'PageTitle_EditMessageTemplate',
            mainContent: MessageTemplateDetails
        }
    ]
};

export default routes;
